<template>
  <div>
    <button type='button' :class='buttonClass' ref='audioPlay' @click='isPlaying = !isPlaying'>재생</button>
  </div>
</template>

<script>
import $EventBus from '$src/prototypes/eventBus';

const LOADING_DELAY = 700;

export default {
  props: {
    fileUrl: String,
  },
  data() {
    return {
      audio: null,
      isPlaying: false,
    };
  },
  watch: {
    isPlaying(val) {
      if (val) {
        this.$EventBus.$emit('health.audioPlay', this);
        this.play();
      } else {
        this.stop();
      }
    },
  },
  computed: {
    buttonClass() {
      return this.isPlaying ? 'btn_audio_stop' : 'btn_audio_play';
    },
  },
  methods: {
    play() {
      const audio = new Audio(this.fileUrl);
      $EventBus.$emit('loading', true);

      audio.addEventListener('canplaythrough', () => {
        audio.play();
        this.audio = audio;
        setTimeout(() => $EventBus.$emit('loading', false), LOADING_DELAY);
      });

      audio.addEventListener('error', (e) => {
        if (this.audio) {
          this.stop();
          setTimeout(() => $EventBus.$emit('loading', false), LOADING_DELAY);
        }
      });
    },
    stop: function() {
      if (!this.audio) return;
      this.audio.setAttribute('src', '');
      this.audio.pause();

      setTimeout(() => {
        if (this.audio) {
          this.audio.load();
          this.audio = null;
        }
      });
    },
    onGlobalAudioPlayed(requestComp) {
      if (requestComp !== this) this.isPlaying = false;
    },
  },
  mounted() {
    this.$EventBus.listen(this, 'health.audioPlay', this.onGlobalAudioPlayed);
  },
  beforeDestroy() {
    this.stop();
  },
};
</script>
